import React, { PropTypes } from "react";

export default function PagingView({ pages, current, onChangePage, labels }) {
    const children = pages.map(
        page => (
          <li key={page} className={`list-item${page === current ? " active" : ""}`}>
            <a
              href={`#${page}`}
              className={`${parseInt(page, 10) !== page ? ` ${page}` : ""}`}
              onClick={(event) => {
                  event.preventDefault();
                  onChangePage(page);
              }}
            >{makeLabel(labels,page)}</a>
          </li>
            ),
    );

    function makeLabel(labels, page) {
        if(labels[page] === undefined) {
            return page;
        } else if ( labels[page] === 'Next') {
            return <i className="icon icon-next"></i>;
        } else if ( labels[page] === 'Previous') {
            return <i className="icon icon-previous"></i>;
        } else if ( labels[page] === 'Next 5') {
            return '...';
        } else if ( labels[page] === 'Previous 5') {
            return '...';
        }
    }

    return (
      <div className="pages">
        <ul className="pagination pagination-sm list-paging">{children}</ul>
      </div>
    );
}
PagingView.propTypes = {
    current: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pages: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ),
    onChangePage: PropTypes.func.isRequired,
    labels: PropTypes.shape({}).isRequired,
};
PagingView.defaultProps = {
    current: 1,
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Common/Views/PagingView.jsx